import {SearchDevices} from "../../../Commands";
import React, {Fragment, SyntheticEvent, useEffect, useRef, useState} from "react";
import DimmerComponent from "./components/Dimmer/DimmerComponent";
import {Esp} from "../../../Targets";
import {Spinner} from "reactstrap";
import AdminComponent from "../../auth/AdminComponent/AdminComponent";
import AddExternalDevicesWidget from "./components/AddExternalDevicesWidget/AddExternalDevicesWidget";
import {Accordion, Checkbox, toaster, Whisper} from "rsuite";
import StatusControl from "../../shared/StatusControl/StatusControl";
import UpsComponent from "./components/Ups/UpsComponent";
import MechanismComponent from "./components/Mechanism/MechanismComponent";
import {SharedApi} from "../../../services/Shared.api";
import {getTooltip} from "../../../shared/Tooltip";
import ElectronicClockComponent from "./components/ElectronicClock/ElectronicClock";
import LedPanel from "./components/LedPanel/LedPanel";
import SensorBlock from "./components/SensorBlock/SensorBlock";
import {useNavigate} from "react-router-dom";
import {
  ExecuteCommandResult,
  ExternalDeviceType,
  ExternalDeviceItem,
  ExternalDevicesProps,
  ExternalDevicesResult
} from "./ExternalDevices.model";
import {ExternalDevicesUtils} from "./ExternalDevices.utils";
import NotificationFactory from "../../../shared/Notifications";
import DeviceFirmware from "./components/DeviceFirmware/DeviceFirmware";

const ExternalDevices = ({
                           executeCommand,
                           clockStationId,
                           selectedDeviceId,
                           deviceId,
                           isAdmin
}: ExternalDevicesProps) => {

  const defaultDeviceType = -1;
  const [loading, setLoading] = useState(false);
  const [deviceAddresses, setDeviceAddresses] = useState<ExternalDeviceItem[]>([]);
  const [activeKey, setActiveKey] = useState(-1);
  const navigate = useNavigate();
  const panelRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    getDevices().then()
  }, []);

  const getDevices = async () => {
    if (!clockStationId) return;
    setLoading(true);

    try {
      const result = await SharedApi.getDevices(String(clockStationId));
      setDevicesResult(result)
    } catch (error) {
      console.error('Ошибка :', error);
      throw error;
    } finally {
      setLoading(false)
    }
  }

  const handleSelectAccordion = (nextKey: string | number | undefined, _event: SyntheticEvent) => {
    const normalizedKey = ExternalDevicesUtils.normalizeAccordionKey(nextKey);

    setActiveKey(normalizedKey);

    if (normalizedKey >= 0) {
      const dev = deviceAddresses[normalizedKey];
      if (dev && deviceId) {
        navigate(`/devices/${deviceId}?tab=devices&externalId=${dev.id}`);
      }
    } else if (deviceId) {
      navigate(`/devices/${deviceId}?tab=devices`);
    }
  };

  useEffect(() => {
    if (activeKey === null || activeKey < 0) return;

    const el = panelRefs.current[activeKey];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeKey]);



  const searchDevicesAddresses = async () => {
      setLoading(true);
      setDeviceAddresses([])

    try {
      const result = await executeCommand(Esp, SearchDevices, []) as ExternalDevicesResult | ExecuteCommandResult

      setDevicesResult(result as ExternalDevicesResult)
    } finally {
      setLoading(false)
    }
  }

  const setDevicesResult = (result: ExternalDevicesResult) => {
    const totalResult: ExternalDeviceItem[] = ExternalDevicesUtils.buildDeviceAddresses(result);

    setDeviceAddresses(totalResult)

    if (totalResult.length === 0) {
      setActiveKey(-1);
      return;
    }

    setActiveKey(ExternalDevicesUtils.getSelectedDeviceIndex(totalResult, selectedDeviceId));

  }

  const renderCurrentDevice = (device: ExternalDeviceItem | null) => {

    if (device === null || device.type === defaultDeviceType)
      return;
    if (device.type === ExternalDeviceType.DimmerD || device.type === ExternalDeviceType.DimmerS) {
      return (
        <Fragment>
          <DimmerComponent
            deviceId={device?.id}
            deviceType={device.type}
            isAdmin={isAdmin}/>
        </Fragment>
      )
    }
    if (
      device.type === ExternalDeviceType.ClockMechanicE ||
      device.type === ExternalDeviceType.ClockMechanicN ||
      device.type === ExternalDeviceType.ClockMechanicV
    ) {
      return (
        <Fragment>
          <h4>Часовой механизм</h4>
          <MechanismComponent
            mechanismId={device?.id}
            deviceType={device.type}
            isAdmin={isAdmin}
            isConnected={device?.isConnected}
          />
        </Fragment>
      )
    }

    // if (!device?.isConnected) {
    //   return  (<div> Не в сети </div>)
    // }
    if (device.type === ExternalDeviceType.ElectronicClock ) {
      return (
        <>
          <ElectronicClockComponent
            deviceId={deviceId}
            id={device.id}
            isAdmin={isAdmin}
          />
        </>
      )

    }

    if (device.type === ExternalDeviceType.LedPanel) {
      return (
        <LedPanel
          deviceId={deviceId}
          id={device.id}
          isAdmin={isAdmin}
        />
      )
    }

    if (device.type === ExternalDeviceType.UpsI ) {
      return (
        <>
          <h4>ИБП</h4>
          <UpsComponent upsId={device?.id} isAdmin={isAdmin}/>
        </>
      )
    }

    if (device.type === ExternalDeviceType.SensorBlockT ) {
      return (
        <>
          <SensorBlock sensorId={device?.id} isAdmin={isAdmin}/>
        </>
      )
    }
  }

  const handleCheckboxClick = async (device: ExternalDeviceItem, e: SyntheticEvent<Element>) => {
    e.stopPropagation();
    const newVisibility = !device.isVisible;

    try {
      const response = await SharedApi.changeVisibility(String(device.id), newVisibility);
      if (response) {
        toaster.push(NotificationFactory.success(), {
          placement: "topEnd",
          duration: 3000
        });

        const updatedDevices = deviceAddresses.map(item =>
          item.id === device.id
            ? {...item, isVisible: newVisibility}
            : item
        );
        setDeviceAddresses(updatedDevices);
      }
    } catch (error) {
      toaster.push(NotificationFactory.error(), {
        placement: "topEnd",
        duration: 3000
      });
      console.error("Ошибка при изменении видимости устройства:", error);
    }
  };

  return (
    <Fragment>
      <AddExternalDevicesWidget clockStationId={clockStationId != null ? String(clockStationId) : undefined}/>
      <div className="input-group mb-3">
        {
          loading ?
            (
              <span className={"btn"}>
                <Spinner/>
              </span>
            ) : null
        }
        <button className="btn btn-outline-secondary" type="button" onClick={getDevices} disabled={loading}>
          Обновить
        </button>
        <AdminComponent>
          {
            () => (
              <button className="btn btn-outline-danger" type="button" onClick={searchDevicesAddresses} disabled={loading}>
                Поиск
              </button>
            )
          }
        </AdminComponent>
      </div>
      <>
        <hr/>
        <Accordion activeKey={activeKey} bordered onSelect={handleSelectAccordion}>
          {
            deviceAddresses.map((device, index) => (
              <div
                key={index}
                ref={(el) => {
                  panelRefs.current[index] = el;
                }}
              >
              <Accordion.Panel
                header={(
                  <div className="d-flex align-items-center">
                    <Whisper
                      placement="topStart"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={getTooltip('Добавить на главную')}>
                    <Checkbox
                      checked={device.isVisible}
                      onClick={(e) => handleCheckboxClick(device, e)}
                    />
                    </Whisper>
                    <span style={{marginLeft: 8}}>{device.text}</span>
                    <StatusControl status={device.isConnected ? "online" : "offline"}/>
                  </div>
                )}
                eventKey={index}
              >
                {index === activeKey && (
                  <>
                    {renderCurrentDevice(device)}
                    {isAdmin && device.id && <DeviceFirmware deviceId={device.id}/>}
                  </>
                )}
              </Accordion.Panel>
              </div>
            ))
          }
        </Accordion>
      </>
    </Fragment>
  )
}

export default ExternalDevices;
